import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import {
    ClosingBlockSection,
    ContentWrapper,
    CoreTitle,
    CoreSlogan,
    FourPetalFlower,
    FourPetalFlower2
} from "./styles";
import { ContentBlockProps } from "./types";

const ClosingBlock = ({
    title,
    slogan
}: ContentBlockProps) => {
    return (
        <ClosingBlockSection>
            <Fade triggerOnce duration={2000}>
                <FourPetalFlower>
                    <div className="petal-horizontal" />
                    <div className="petal-vertical" />
                </FourPetalFlower>
            </Fade>
            <Row justify="center" align="middle">
                <ContentWrapper>
                    <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
                        <CoreTitle>{title}</CoreTitle>
                        <CoreSlogan>{slogan}</CoreSlogan>
                    </Col>
                </ContentWrapper>
            </Row>
            <Fade triggerOnce duration={2000} delay={500}>
                <FourPetalFlower2>
                    <div className="petal-horizontal" />
                    <div className="petal-vertical" />
                </FourPetalFlower2>
            </Fade>
        </ClosingBlockSection>
    );
};

export default withTranslation()(ClosingBlock);
